import React, { useState, useContext, useEffect } from 'react';
import {
  Box,
  Drawer,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
  AppBar,
  Toolbar,
} from '@mui/material';
import { Menu as MenuBurgerIcon } from '@mui/icons-material';
import { useLocation, Outlet, useNavigate, useFetcher } from 'react-router-dom';
import Sidebar from './dashboard/Sidebar';
import { BusinessContext } from "./BusinessContext";
import axiosInstance from './axios';

const UserDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname.split('/').pop();
  
  const [selectedItem, setSelectedItem] = useState(() => {
    switch(currentPath) {
      case 'dashboard': return 'Dashboard';
      case 'genietags': return 'Genie Tag';
      case 'orders': return 'Orders';
      case 'offers' : return 'Offers';
      case 'menu': return 'Menu';
      case 'sociallinks': return 'Social Networks';
      case 'profile': return 'Profile';
      case 'customerorders': return 'Customer Orders';
      case 'businessreports': return 'Business Reports';
      case 'assignplates' : return 'Assign Plates';
      case 'photos' : return 'Photos';
      case 'businessreport': return 'Business Report'
      default: return 'Dashboard';
    }
  });

  // Effect to handle initial navigation and URL sync
  useEffect(() => {
    if (location.pathname === '/dashboard') {
      navigate('/dashboard/dashboard');
      setSelectedItem('Dashboard');
    } else {
      const path = location.pathname.split('/').pop();
      switch(path) {
        case 'dashboard':
          setSelectedItem('Dashboard');
          break;
        case 'genietags':
          setSelectedItem('Genie Tag');
          break;
        case 'orders':
          setSelectedItem('Orders');
          break;
          case 'offers':
            setSelectedItem('Offers');
            break;
        case 'menu':
          setSelectedItem('Menu');
          break;
        case 'sociallinks':
          setSelectedItem('Social Networks');
          break;
        case 'profile':
            setSelectedItem('Profile');
            break;
        case 'customerorders':
            setSelectedItem('Customer Orders');
            break;
        case 'businessreports':
            setSelectedItem('Business Reports');
            break;
        case 'photos':
                setSelectedItem('Photos');
                break;
                case 'businessreport':
                  setSelectedItem('Business Report');
                  break;
        default:
          break;
      }
    }
  }, [location.pathname, navigate]);

  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const themeColors = theme.palette.pointGenie;
  const dashboardBg =
    theme.palette.mode === "dark" ? themeColors.bg : "#e5e5e5";
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { isLoading } = useContext(BusinessContext);

  const handleMenuItemClick = (itemText) => {
    setSelectedItem(itemText);
    if (isMobile) {
      setMobileOpen(false);
    }
  };

 const fetchUserDetails = async () => {
      try {
        const response = await axiosInstance.post("user.php?method=get_user_details");
        if (response.data?.user?.name) {
          console.log("User Name from API:")
        } else {
          console.error("Name field is missing or empty.");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    const fetchBusinesses = async () => {
      try {
        const response = await axiosInstance.post(
          'user.php?method=get_user_buinesses',
        );
  
        if (response.data?.status === "success") {
          const businessList = response.data.orders || [];
        }
      } catch (error) {
        console.error("Failed to fetch businesses:", error);
      } 
    };
  
useEffect(()=>
{
  fetchBusinesses();
  fetchUserDetails();
},[])
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: dashboardBg }}>
      {isMobile && (
        <AppBar position="fixed" sx={{ backgroundColor: '#1a237e' }}>
          <Toolbar>
            <IconButton color="inherit" edge="start" onClick={() => setMobileOpen(!mobileOpen)}>
              <MenuBurgerIcon />
            </IconButton>
            <Typography variant="h6" sx={{ flexGrow: 1, ml: 2 }}>
              {selectedItem}
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={() => setMobileOpen(false)}
        sx={{
          width: 240,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 240,
            boxSizing: 'border-box',
            border: 'none',
          },
        }}
      >
        <Sidebar selectedItem={selectedItem} onMenuItemClick={handleMenuItemClick} />
      </Drawer>
      <Box
        className="pg-dashboard-main"
        component="main"
        sx={{
          overflowX: { xs: "hidden", sm: "auto" },
          flexGrow: 1,
          p: { xs: 0, sm: 3 },
          marginTop: isMobile ? '64px' : 0,
          minHeight: isMobile ? 'calc(100vh - 64px)' : '100vh',
          backgroundColor: dashboardBg,
          color: themeColors.text,
        }}
      >
        {isLoading ? <Typography></Typography> : <Outlet />}
      </Box>
    </Box>
  );
};

export default UserDashboard;
